export default __webpack_public_path__ + "static/media/conti.55a016c8.png";